import store from './actions/store';
import { LOGOUT, LOGIN } from './actions/types';
import { setHiddenItemsId } from "./actions/sidebarActions";
import axios from 'axios';

const SESSION_KEY = 'marketplace_session';
const INACTIVITY_LIMIT = 2 * 60 * 60 * 1000; // 2 horas en milisegundos

class Auth {
  constructor() {
    this.authenticated = false;
  }

  isAuthenticated = () => {
    const isAuth = store.getState().general.isAuthenticated || false;
    return isAuth;
  }

  login(idSeller, userName, tipoUsuario, userId, hiddenItemsIds, codProv) {
    const payload = {
      idSeller,
      userName,
      tipoUsuario,
      tipoUsuario,
      userId,
      codProv
    };

    store.dispatch({
      type: LOGIN,
      payload: {
        idSeller,
        userName,
        tipoUsuario,
        userName,
        tipoUsuario,
        userId,
        codProv
      }
    });

    store.dispatch(setHiddenItemsId(hiddenItemsIds));
    this.saveSession({ ...payload, hiddenItemsIds });
  }

  logout() {
    this.clearSession();
    store.dispatch({
      type: LOGOUT,
      payload: false,
    });
  }

  saveSession(data) {
    const sessionData = {
      ...data,
      lastActivity: Date.now()
    };
    try {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
    } catch (e) {
      console.error("Error saving to sessionStorage:", e);
    }
  }

  clearSession() {
    window.sessionStorage.removeItem(SESSION_KEY);
    window.localStorage.removeItem("token");
    delete axios.defaults.headers.common['Authorization'];
  }

  updateActivity() {
    const session = window.sessionStorage.getItem(SESSION_KEY);
    if (session) {
      const data = JSON.parse(session);
      data.lastActivity = Date.now();
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    }
  }

  // Combina la lógica de initSession y checkSession
  checkSession() {
    const session = window.sessionStorage.getItem(SESSION_KEY);
    const token = window.localStorage.getItem("token");

    if (!session || !token) {
      // If we have no session/token, but we thought we were logged in? 
      // Por ahora solo retorna, el estado de la aplicación generalmente comienza como no autenticado.
      return;
    }

    try {
      const data = JSON.parse(session);
      const now = Date.now();

      if (now - data.lastActivity > INACTIVITY_LIMIT) {
        this.logout();
      } else {
        // Restore Axios Header
        axios.defaults.headers.common['Authorization'] = token;

        // Restore Redux State
        store.dispatch({
          type: LOGIN,
          payload: {
            idSeller: data.idSeller,
            userName: data.userName,
            tipoUsuario: data.tipoUsuario,
            tipoUsuario: data.tipoUsuario,
            userId: data.userId,
            codProv: data.codProv
          }
        });

        if (data.hiddenItemsIds) {
          store.dispatch(setHiddenItemsId(data.hiddenItemsIds));
        }

        this.updateActivity();
      }
    } catch (e) {
      console.error("Error restoring session", e);
      this.logout();
    }

  }
}

export default new Auth();